<template>
  <div>
    <button :disabled="disabled" @click="clickHandler" type="submit" class="submit-button w-button">
      <div v-if="loading" class="lds-ripple">
        <div></div>
        <div></div>
      </div>
      <slot v-else/>
    </button>
  </div>
</template>
<script>
export default {
  name: "smart-button",
  props: {
    loading: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickHandler() {
      this.$emit("click")
    }
  }
}
</script>
<style>
.submit-button{
  height: 50px;
  line-height: 40px;
  padding-top: 0px;
  padding-bottom: 0px;
  min-width: 180px;
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  zoom: 0.4;
  bottom:-20px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
</style>